<nb-card>
  <nb-card-header>
    <div>
      <button
        [ngClass]="menu == 'info' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'info' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltip="Thông tin"
        nbTooltipPlacement="bottom"
        (click)="selectMenu('info')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        <span>Thông tin</span>
      </button>

      <button
        *ngIf="mode == 'edit'"
        [ngClass]="menu == 'content' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'content' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltip="Nội dung"
        nbTooltipPlacement="bottom"
        (click)="selectMenu('content')"
      >
        <nb-icon class="button-icon" icon="layers-outline"></nb-icon>
        <span>Danh sách câu hỏi</span>
      </button>
    </div>

    <button
      class="cancel"
      nbButton
      ghost
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body *ngIf="menu == 'info'">
    <form [formGroup]="diaForm">
      <div class="form-group">
        <div class="label">
          <h6 class="text-primary">Tiêu đề</h6>
          <p class="text-hint">Ngắn gọn, rõ ràng nêu lên chủ đề cần chia sẻ</p>
        </div>

        <input
          type="text"
          nbInput
          fullWidth
          formControlName="title"
          placeholder="Nhập tiêu đề"
          class="form-control"
          [(ngModel)]="exercise.title"
        />
      </div>
      <div class="form-group">
        <div class="label">
          <h6 class="text-primary">Mô tả</h6>
          <p class="text-hint">
            Tóm tắt nội dung ngắn gọn, giúp người đọc có thể nắm nhanh được bài
            viết
          </p>
        </div>

        <textarea
          nbInput
          fullWidth
          id="inputDescription"
          placeholder="Nhập mô tả"
          class="form-control"
          formControlName="description"
          [(ngModel)]="exercise.description"
        ></textarea>
      </div>
    </form>

    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label class="label"
            >Hình đại diện
            <button
              nbButton
              ghost
              size="none"
              status="danger"
              [disabled]="submitted"
              [class.btn-pulse]="submitted"
              (click)="removeCoverUrl()"
            >
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </label>
          <ngx-upload-image
            [size]="'tiny'"
            [mode]="'imagekit'"
            [path]="'/exercise/cover'"
            [imageURL]="imageURL"
            (onUploadSuccess)="updateImage($event)"
          ></ngx-upload-image>
        </div>
      </div>

      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label class="label"> % vượt thử thách</label>
          <input
            type="number"
            nbInput
            fullWidth
            placeholder="Nhập % để vượt thử thách, vd: 80%"
            class="form-control"
            [(ngModel)]="exercise.percentCompleted"
          />
        </div>

        <div class="form-group">
          <label class="label"> Thời gian (phút)</label>
          <input
            type="number"
            nbInput
            fullWidth
            placeholder="Nhập số phút thử thách. Bằng 0 là không tính thời gian"
            class="form-control"
            [(ngModel)]="exercise.duration"
          />
        </div>

        <!-- <div class="form-group">
          <label class="label"> Thông điệp khi hoàn thành</label>
          <ngx-editor-document            
            [(ngModel)]="exercise.messageCompleted"
          ></ngx-editor-document>
        </div> -->

        <div class="form-group">
          <label class="label">Nhập phân loại ( Tag)</label>
          <nb-tag-list (tagRemove)="onTagRemove($event)">
            <nb-tag *ngFor="let tree of trees" [text]="tree" removable></nb-tag>
            <input
              type="text"
              nbTagInput
              (tagAdd)="onTagAdd($event)"
              fullWidth
            />
          </nb-tag-list>
        </div>

        <div *ngIf="user.admin || user.moderator" class="form-group">
          <label class="label">Chia sẻ</label>
          <nb-radio-group [(ngModel)]="exercise.privacy">
            <nb-radio [checked]="exercise.privacy" [value]="true"
              >Khóa học
            </nb-radio>

            <nb-radio [checked]="!exercise.privacy" [value]="false"
              >Cộng đồng</nb-radio
            >
          </nb-radio-group>
        </div>

        <div *ngIf="user.admin || user.moderator" class="form-group">
          <nb-checkbox [(ngModel)]="exercise.newComment" status="warning"
            >Bình luận mới</nb-checkbox
          >
          <nb-checkbox [(ngModel)]="exercise.showComments" status="info"
            >Xem bình luận</nb-checkbox
          >
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-body *ngIf="menu == 'content'">
    <ngx-exercise-quizzes
      [exercise]="exercise"
      (onUpdateQuizzes)="updateQuizzes($event)"
    >
    </ngx-exercise-quizzes>
  </nb-card-body>

  <nb-card-footer>
    <nb-select
      hero
      size="small"
      [status]="status == '1' ? 'success' : status == '0' ? 'info' : 'warning'"
      placeholder="Chọn trạng thái"
      [(ngModel)]="status"
    >
      <nb-option value="1">Xuất bản</nb-option>
      <nb-option value="0">Đang thực hiện</nb-option>
      <nb-option value="-1">Ẩn nội dung</nb-option>
    </nb-select>
    <button
      type="submit"
      nbButton
      status="primary"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      Lưu
    </button>
  </nb-card-footer>
</nb-card>
